/* Modded Moto Co - prominent centered "View all" buttons under each homepage
 * collection section. Inserts a fresh button (theme's own link styling is
 * stubborn) centered below the section and hides the original text link.
 */
(function () {
  'use strict';
  if (window.__mmcViewAll) return;
  window.__mmcViewAll = true;

  function injectStyles() {
    if (document.getElementById('mmc-viewall-style')) return;
    var css =
      '.mmc-viewall-wrap{display:flex;justify-content:center;width:100%;margin:14px 0 4px;}' +
      '.mmc-viewall-btn{display:inline-flex;align-items:center;justify-content:center;padding:14px 50px;border-radius:999px;background:#111111;color:#ffffff;font-weight:800;font-size:15px;letter-spacing:.05em;text-transform:uppercase;text-decoration:none;border:2px solid #111111;transition:background .15s,border-color .15s;}' +
      '.mmc-viewall-btn:hover{background:#333333;border-color:#333333;color:#ffffff;}' +
      '@media (max-width:749px){.mmc-viewall-btn{padding:14px 44px;font-size:14px;width:auto;}}';
    var s = document.createElement('style');
    s.id = 'mmc-viewall-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function enhance() {
    var links = document.querySelectorAll('a[href^="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.dataset.mmcViewall || a.classList.contains('mmc-viewall-btn')) continue;
      var t = (a.textContent || '').trim();
      if (!/^view all$/i.test(t)) continue;
      a.dataset.mmcViewall = '1';
      var wrap = a.closest('[class*="section-body-button"]') || a.parentElement;
      if (!wrap || !wrap.parentNode) continue;
      var fresh = document.createElement('a');
      fresh.className = 'mmc-viewall-btn';
      fresh.href = a.getAttribute('href');
      fresh.textContent = 'View all';
      var holder = document.createElement('div');
      holder.className = 'mmc-viewall-wrap';
      holder.appendChild(fresh);
      a.style.display = 'none';
      wrap.parentNode.insertBefore(holder, wrap.nextSibling);
    }
  }

  function init() {
    injectStyles();
    var tries = 0;
    (function attempt() {
      enhance();
      if (tries++ > 12) return;
      setTimeout(attempt, 350);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
